import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('/media/deltapro/h5/');
export default function CardmsgD({}: any) {
    const { useLang } = useGlobal();
    const { t } = useLang('delta_pro_new');

    return (
        <div
            className={`${css.cardmsgD} ${css.cardmsgD1} cardmsgD1 GtmModuleData-section`}
            data-section-id={css.cardmsgD}
            data-section-title={t('wired_control')}
            style={{ height: '5rem' }}
        >
            <div className="card-msgs">
                <div className="card-title">{t('wired_control')}</div>
                <div className="card-desc">{t('wired_control_desc')}</div>
            </div>
            <div className="card-img" style={{ height: '5rem' }}>
                <EFPic name={[`12WiredControl.webp`, `12WiredControl.png`]} className="fullImgs" alt={t('wired_control')} />
            </div>
        </div>
    );
}
